<template>
  <FormElement type="input" small >
    <template slot="label">
      <span>{{ label }}</span>
    </template>

    <template slot="warning">
      <span class="-require" v-if="required">*ต้องกรอกข้อมูล</span>
    </template>

    <template slot="controller">
      <slot name="controller" />
      <button class="--input-clear" @click="input = prev">
        <vs-icon icon="restore" size="small"></vs-icon>
      </button>
      <button class="--input-clear" @click="input = ''">
        <vs-icon icon="delete_forever" size="small"></vs-icon>
      </button>
    </template>

    <div
      class="input-box"
    >
      <input type="text"
        v-model="input"
      >
    </div>
  </FormElement>
</template>

<script>
import FormElement from '../form-element';

export default {
  components: {
    FormElement
  },
  props: {
    label: String,
    prop: [String, Array, Object],
    required: {
      type: Boolean,
      default: false,
    },
    edata: {
      type: [String, Number],
      default: null
    },
    min: {
      type: Number,
      default: 0
    },
    small: {
      type: Boolean,
      default: false
    },
    dataType: {
      type: String,
      default: "string"
    },
    outputMode: String
  },
  data: () => ({
    input: "",
    prev: "",
  }),
  watch: {
    input: function (key) {
      if (this.prop && key) {
        if (key.length >= this.min) {
          if (Array.isArray(this.prop)) {
            const multipleValues = {};
            if (this.outputMode === "flat") {
              this.prop.map(field => {
                if (typeof field === "string") {
                  multipleValues[field] = preserveDataType(key, this.dataType);
                } else if (typeof field === "object") {
                  if (field.transform) {
                    multipleValues[field.transform] = preserveDataType(key, this.dataType);
                  } else {
                    multipleValues[field.target] = preserveDataType(key, this.dataType);
                  }
                }
              });
            } else {
              this.prop.map(field => {
                multipleValues[field] = preserveDataType(key, this.dataType);
              });
              // TODO: Add normal mode
            }
            this.$emit("input", { ...multipleValues });
          } else if (typeof this.prop === 'object' && this.prop !== null) {
            this.$emit("input", { prop: this.prop.transform, data: preserveDataType(key, this.dataType) })
          } else {
            this.$emit("input", { prop: this.prop, data: preserveDataType(key, this.dataType) });
          }
        } else {
          this.$emit("input", { prop: "", data: null });
        }
      } else {
        this.$emit("input", null);
      }
    },
    edata: function (val) {
      if (val) {
        if (this.dataType === "string") {
          this.input = this.edata.toString();
        } else if (this.dataType === "number") {
          this.input = parseInt(this.edata);
        } else {
          this.input = this.edata;
        }
      }
      if (this.prev === "") {
        this.prev = this.edata;
      }
    }
  }
}

function preserveDataType(data, type) {
  try {
    if (type === "string") {
      return data.toString();
    } else if (type === "number") {
      return parseInt(data);
    }
  } catch {
    return data;
  }
}
</script>

<style lang="scss" scoped>
.input-box {

  & input[type="text"] {
    border-color: transparent;
    border-radius: 8px;
    margin-left: 10px;
    font-size: 1.2rem;
    letter-spacing: 0.75px;
  }
}

.--input-clear {
  &:hover {
    color: red !important;
  }
}
</style>
